import useEventStore from '@/stores/useEventStore';

export type EventListResetScope =
  | {
      kind: 'home';
    }
  | {
      eventId: string;
      kind: 'detail';
    };

export function useQueuedEventListResetDate(scope: EventListResetScope) {
  return useEventStore((state) => {
    if (scope.kind === 'home') {
      return state.homeJumpDate;
    }

    return state.detailJumpDateByEventId[scope.eventId];
  });
}

export function clearQueuedEventListReset(scope: EventListResetScope) {
  if (scope.kind === 'home') {
    useEventStore.setState({
      homeJumpDate: undefined,
    });
    return;
  }

  useEventStore.setState((state) => ({
    detailJumpDateByEventId: {
      ...state.detailJumpDateByEventId,
      [scope.eventId]: undefined,
    },
  }));
}

export function queueEventListReset({
  datetime,
  parentEventId,
}: {
  datetime?: string | null;
  parentEventId?: string | null;
}) {
  if (!datetime) {
    return;
  }

  useEventStore.setState((state) => ({
    homeJumpDate: datetime,
    ...(parentEventId
      ? {
          detailJumpDateByEventId: {
            ...state.detailJumpDateByEventId,
            [parentEventId]: datetime,
          },
        }
      : {}),
  }));
}
